import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from '@sc/data-access-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigHttpService {
  private readonly apiUrl = '/api/config';
  private readonly allConfigsApiUrl = '/api/configs';

  constructor(private readonly httpClient: HttpClient) {}

  fetchConfig(): Observable<Configuration> {
    return this.httpClient.get<Configuration>(`${this.apiUrl}`, {
      headers: { requestName: 'config-http fetchConfig' },
    });
  }

  superAdminGetAllConfigs(configIds?: string[]): Observable<Configuration[]> {
    return this.httpClient
      .post<{ configList: Configuration[] }>(
        `${this.allConfigsApiUrl}`,
        { configIdList: configIds },
        {
          headers: { requestName: 'config-http superAdminGetAllConfigs' },
        }
      )
      .pipe(map((configsResult) => configsResult.configList));
  }
}
